// Footer.js
import React from 'react';
import './Footer.css'; // Import the CSS file for styling

const Footer = () => {
  return (
    <footer className="footer">
      <div className='contacts'>
     <h3> CONTACT ME</h3>
      <p>Email: johndalepardillo@gmail.com</p> 
       <p>Phone: 09162815212</p> 
      </div>
    <p className='company'>2023 Portfolio. All rights reserved.</p>
    </footer>
  );
}

export default Footer;
